export default __webpack_public_path__ + "static/media/outer-bottom-corners-rounded.c3d127bc.webp";